export default __webpack_public_path__ + "d5abfb3b9a584d07e5ace268b7a9394e.png";